<script lang="ts">
    import type Monster from "../../lib/monster";
    import { getPathFor } from "../Attributes/util";
    import type { Point } from "../Attributes/util";
    import { convertNormalizedPath, generateFillColor } from "./util";
    export let monster: Monster;
    export let dimensions: number;
    const normalizedRange = 10;

    const generatePath = (sideLength: number): Point[] => {
        const path: Point[] = convertNormalizedPath(
            [
                { x: 1.15, y: 8.65 },
                { x: 6.65, y: 3.15 },
                { x: 6, y: 2 },
                { x: 6, y: 1.5 },
                { x: 7, y: 0.5 },
                { x: 7, y: 1 },
                { x: 7, y: 3 },
                { x: 9, y: 3 },
                { x: 9.5, y: 3 },
                { x: 8.5, y: 4 },
                { x: 8, y: 4 },
                { x: 6.85, y: 3.35 },
                { x: 1.35, y: 8.85 },
                { x: null, y: null },
                { x: 7.5, y: 2.5 },
                { x: 7.5, y: 1.5 },
                { x: 8.5, y: 1.5 },
                { x: 8.5, y: 2.5 },
            ],
            sideLength * 2,
        );

        return path;
    };
</script>

{#if dimensions}
    <path
        d={getPathFor(generatePath(dimensions))(
            { x: dimensions / 2, y: dimensions / 2 },
            normalizedRange
        )}
        stroke="black"
        fill={generateFillColor('magic', monster)}
    />
{/if}

<style>
</style>
